// 정책 고지 정본값 (웹 표시용 기본값) — 2026-09-16
// 근거: docs/위치기반서비스_이용약관_v1.1_게시본_2026-09-16.md §9-3·§9-4.
// Firestore config/policyNotices 의 같은 키 값이 있으면 그 값이 우선하고, 없으면 여기 값으로 표시한다(게시 공백 방지).
// 운영 Firestore 쓰기는 이 파일이 하지 않는다 — 등록은 scratchpad/seed-policy-notice-lbs-v11.js (메인 실행).

export const LBS_TERMS_V11_KEY = 'lbsTermsV11';

export const POLICY_NOTICES = {
    [LBS_TERMS_V11_KEY]: {
        kind: 'lbs_terms',
        version: 'v1.1',
        title: '위치기반서비스 이용약관 개정 안내',
        body: '위치기반서비스 이용약관이 2026년 10월 17일부터 바뀝니다. 현재 위치를 약 100m 단위로 줄여 이용한다는 점, 검색과 지도 표시를 위해 주식회사 카카오에 전달된다는 점, 법에서 정한 이용 기록(위치·접속 정보 제외)을 6개월 보관한다는 점을 실제 처리대로 적었습니다.',
        postedAt: '2026-09-16',
        effectiveAt: '2026-10-17',   // 이 날짜가 지나면 배너는 자동으로 내려간다(기록은 남긴다)
        link: '/location-terms',
        // 실제 라우트(App.js 확인): 치과 찾기 /find-clinic · 기공소 찾기 /find-lab · 재제작 상담 /as-remake · 약관 /location-terms
        pages: ['/find-clinic', '/find-lab', '/as-remake', '/location-terms'],
    },
};
